export default __webpack_public_path__ + "static/media/wp3616722 (1).ce7b93db.png";